import { IResponseBase, IPagedResultset } from "./app";


export interface ICustTypeDto {
	Name: string;
	ListID: string;
	CustTypeFlags: CustTypeFlags[];
	IsDealership: boolean;
	IsRetail: boolean;
}


export enum CustTypeFlags {
	ShowCompany = 10,
	ShowFnameLastName = 20,

	EmailReadOnly = 30,
	BillingAddressEditable = 40,

	TaxEditable = 45,
	NonTaxDefault = 50,
	TaxDefault = 60,

	PurchaseOrderAllowed = 70,
	PurchaseOrderNotAllowed = 80,
	PurchaseOrderOnly = 100,

	HideStockColorMileage = 90,

	ShowMaterialCharge = 110,

	AuthorizationNumberOnly = 120,
}



export interface ICustomer {
	RecordID?: number;
	Shipping: ICustomerAddress;
	Billing: ICustomerAddress;
	QbInfo: IQbInfo;
	CustType: ICustTypeDto;
}

export interface IQbInfo {
	ListID?: string;
	FullName?: string;
	Company?: string;
	Email?: string;
	IsActive?: boolean;
	Balance?: number;
	TotalBalance?: number;
	JobStatus?: string;
	BillAddr1?: string;
	BillAddr2?: string;
	BillCity?: string;
	BillState?: string;
	BillZip?: string;
	Tax?: string;
	TaxState?: string;
}

export interface ICustomerAddress {
	CustomerName: string;
	Company: string;
	FName: string;
	LName: string;
	Email: string;
	Phone: string;
	Mobile: string;
	Address: string;
	Address2: string;
	City: string;
	State: string;
	Zip: string;
}

export interface ICustomerResponseData extends IPagedResultset {
	Customers: ICustomer[];
}

export interface ISearchCustomerRequest {
	Keyword: string;
	IsActive?: boolean;
	Page?: number;
	PageSize?: number;
}

export interface ISearchCustomerResponse extends IResponseBase {
	Results: ICustomerResponseData;
}

export interface IUpdateCustomerRequest {
	Customer: ICustomer;
}

export interface IUpdateCustomerResponse extends IResponseBase { }

export interface IInsertCustomerRequest {
	Customer: ICustomer;
}

export interface IInsertCustomerResponse extends IResponseBase {
	CustomerID: number;
}

export interface IGetCustomerRequest {
	CustomerID: number;
}

export interface IGetCustomerResponse extends IResponseBase {
	Customer: ICustomer;
}

export interface IFindEmailResponse extends IResponseBase {
	Results: string[];
}
